export enum enableDisableIDNFeatures {
   enableLaActivity= "14628_TenantUpgrade",
}